import React, { useContext, useEffect, useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";
import { StoreContext } from "../../../../../Store/Provider";
import clsx from "clsx";
import ShipmentCard from "../ShipmentCard/ShipmentCard";
import ShipmentDetails from "../ShipmentDetails/ShipmentDetails";
import SidebarData from "../SidebarData/SidebarData";
import Drawer from "@material-ui/core/Drawer";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import {
  getUserData,
  setUserData,
  localStoragekey,
} from "../../../../Common/Utility/Utils";
import { HOST_URL } from "../../../../../Config";
import axios from "axios";
import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import AdvSearchSvg from "../../../../SVG/AdvSearch";
import Arrived from "../../../../SVG/Arrived";
import AdvSearch from "./AdvSearch2";
import InTransit from "../../../../SVG/InTransit";
import "./shipmentsListing.css";
import PreLoaded from "../../../../SVG/PreLoaded";
import PropagateLoader from "react-spinners/PropagateLoader";
import InfiniteScroll from "react-infinite-scroller";
import { CircularProgress } from "@material-ui/core";
import { NotificationManager } from "react-notifications";
import ContainerDetails from "../SidebarData/ContainerDetails";
import FlightData from "../SidebarData/FlightData";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "1rem",
  p: 2,
};

function ShipmentsListing() {
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(true);
  const [preloadedData, setPreloadedData] = useState({
    data: [],
    loading: true,
    count: 0,
  });
  // console.log("PreloadedData", preloadedData);
  const [loadedData, setLoadedData] = useState({
    data: [],
    loading: true,
    count: 0,
  });
  const [arrivedData, setArrivedData] = useState({
    data: [],
    loading: true,
    count: 0,
  });
  const [detailData, setDetailData] = useState({});
  const [modalOpen, setModalOpen] = React.useState(false);
  const handleOpen = () => setModalOpen(true);
  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") {
      return;
    }
    setModalOpen(false);
  };
  const [pageNumber, setPageNumber] = useState({
    preLoaded: 1,
    loaded: 1,
    arrived: 1,
  });
  const [hasMore, setHasMore] = useState({
    preLoaded: false,
    loaded: false,
    arrived: false,
  });

  useEffect(() => {
    getShipmentListing("Loaded", "2", pageNumber.loaded);
    getShipmentListing("PreLoaded", "1", pageNumber.preLoaded);
    getShipmentListing("Arrived", "3", pageNumber.arrived);
  }, []);

  const getShipmentListing = async (cargoStatus, statusCode, pageNumber) => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    const end_point = `${HOST_URL}api/v1/Shipment/GET`;
    const params = {
      sortCriteria: "Created",
      statusCode: statusCode,
      arrivalStatusCode: "",
      companyCode: userData.orgs,
      sortOrder: "Desc",
      pageNumber: pageNumber,
      pageSize: 20,
    };
    axios
      .post(end_point, params, {
        headers: header,
      })
      .then((res) => {
        // alert(1)
        // console.log(res, statusCode)
        // alert(2)
        console.log(res);
        const length = res.data?.Value?.shipments?.length;
        if (pageNumber === 1 && statusCode === "1") {
          const data = length > 0 ? res.data.Value.shipments[0] : {};
          context.setShipmentNo(data?.ShipmentId);
          handleDrawer(data);
        }
        if (statusCode === "2") {
          let hasMore = length === 20 ? true : false;
          setPageNumber({ ...pageNumber, loaded: pageNumber });
          setLoadedData({
            data: [...loadedData.data, ...res.data.Value.shipments],
            loading: false,
            count: res.data.Value.TotalLoaded,
          });
          setHasMore({ ...hasMore, loaded: hasMore });
        } else if (statusCode === "1") {
          let hasMore = res.data.Value.shipments.length === 20 ? true : false;
          setPageNumber({ ...pageNumber, preLoaded: pageNumber });
          setPreloadedData({
            data: [...preloadedData.data, ...res.data.Value.shipments],
            loading: false,
            count: res.data.Value.TotalPreLoaded,
          });
          setHasMore({ ...hasMore, preLoaded: hasMore });
        } else if (statusCode === "3") {
          let hasMore = res.data.Value.shipments.length === 20 ? true : false;
          setPageNumber({ ...pageNumber, arrived: pageNumber });
          setArrivedData({
            data: [...arrivedData.data, ...res.data.Value.shipments],
            loading: false,
            count: res.data.Value.TotalArrived,
          });
          setHasMore({ ...hasMore, arrived: hasMore });
        }
        context.setSelectedIndex(0);
      })
      .catch((err) => {
        if (statusCode === "2") {
          setLoadedData({ data: [], loading: false, count: 0 });
        } else if (statusCode === "1") {
          setPreloadedData({ data: [], loading: false, count: 0 });
        } else {
          setArrivedData({ data: [], loading: false, count: 0 });
        }
        NotificationManager.error("Something went wrong", "", 3000);
      });
  };

  const handleDrawer = (data = {}) => {
    setDetailData(data);
    if (Object.keys(data).length) {
      context.setSidebarContent("shipmentDetails");
      setOpen(true);
    } else {
      context.setSidebarContent("shipmentDetails");
      setOpen(false);
    }
  };

  const handleChange = (event, newValue) => {
    // console.log("newValue", newValue);
    if (newValue === 1 && loadedData?.data?.length) {
      context.setShipmentNo(loadedData?.data[0]?.ShipmentId);
      // setOpen(true);
      handleDrawer(loadedData?.data[0]);
    } else if (newValue === 0 && preloadedData?.data?.length) {
      context.setShipmentNo(preloadedData?.data[0]?.ShipmentId);
      // setOpen(true);
      handleDrawer(preloadedData?.data[0]);
    } else if (newValue === 2 && arrivedData?.data?.length) {
      context.setShipmentNo(arrivedData?.data[0]?.ShipmentId);
      handleDrawer(arrivedData?.data[0]);
    } else {
      handleDrawer({});
      context.setShipmentNo("");
    }
    setValue(newValue);
    context.setSelectedIndex(0);
  };

  const loadMore = (statusCode) => {
    if (statusCode === "1" && hasMore.preLoaded) {
      const pgNumber = pageNumber.preLoaded + 1;
      getShipmentListing("PreLoaded", statusCode, pgNumber);
      setHasMore({ ...hasMore, preLoaded: false });
    } else if (statusCode === "2" && hasMore.loaded) {
      const pgNumber = pageNumber.loaded + 1;
      getShipmentListing("Loaded", statusCode, pgNumber);
      setHasMore({ ...hasMore, loaded: false });
    } else if (hasMore.arrived) {
      const pgNumber = pageNumber.arrived + 1;
      getShipmentListing("Arrived", statusCode, pgNumber);
      setHasMore({ ...hasMore, arrived: false });
    }
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
          style={
            open
              ? { marginRight: "0%", position: "relative" }
              : { marginRight: "-30%", zIndex: 1, position: "relative" }
          }
        >
          <div className="shipmentsListingHomeInner">
            <div className="ShipmentListingTwo">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                className="shipmentsListingHomeTabRow container"
              >
                <Tab
                  disableRipple
                  label={
                    <div className="shipmentsListingHomeTab ToursixthStep">
                      <div className="shipmentsListingHomeTabIcon">
                        {value === 0 ? (
                          <PreLoaded colorCode={"#fff"} />
                        ) : (
                          <PreLoaded
                            colorCode={"rgba(var(--text-heading-dark))"}
                          />
                        )}
                      </div>
                      <p>
                        Pre-Loaded <span>({preloadedData.count})</span>
                      </p>
                    </div>
                  }
                />
                <Tab
                  disableRipple
                  label={
                    <div className="shipmentsListingHomeTab TourninethStep">
                      <div className="shipmentsListingHomeTabIcon">
                        {value === 1 ? (
                          <InTransit colorCode={"#fff"} />
                        ) : (
                          <InTransit
                            colorCode={"rgba(var(--text-heading-dark))"}
                          />
                        )}
                      </div>
                      <p>
                        In Transit <span>({loadedData.count})</span>
                      </p>
                    </div>
                  }
                />
                <Tab
                  disableRipple
                  label={
                    <div className="shipmentsListingHomeTab TourthirteenthStep">
                      <div className="shipmentsListingHomeTabIcon ">
                        {value === 2 ? (
                          <Arrived colorCode={"#fff"} />
                        ) : (
                          <Arrived
                            colorCode={"rgba(var(--text-heading-dark))"}
                          />
                        )}
                      </div>
                      <p>
                        Arrived <span>({arrivedData.count})</span>
                      </p>
                    </div>
                  }
                />
              </Tabs>
              <div className="advSearchText TourseventeenthStep">
                <div className=" advSearch pointer" onClick={handleOpen}>
                  <AdvSearchSvg colorCode={"#fff"} />
                </div>
                <p className="advText">Filter</p>
              </div>
            </div>
            <TabPanel value={value} index={0}>
              {preloadedData.loading ? (
                <div className="loadingContent">
                  <PropagateLoader
                    color={"rgba(var(--text-heading-dark))"}
                    size={"1.5rem"}
                  />
                </div>
              ) : (
                <InfiniteScroll
                  className="infiniteScroller ShipmentDiv"
                  pageStart={0}
                  loadMore={() => loadMore("1")}
                  hasMore={hasMore.preLoaded}
                  loader={
                    <div className="bottomLoader">
                      <CircularProgress size="1.5rem" />
                    </div>
                  }
                  useWindow={false}
                >
                  {preloadedData.data.length ? (
                    preloadedData.data.map((ele, index) => {
                      return (
                        <ShipmentCard
                          key={ele.ShipmentId}
                          index={index}
                          handleDrawer={handleDrawer}
                          loadedData={ele}
                        />
                      );
                    })
                  ) : (
                    <span className="noShipmentsDiv">Shipment not found!</span>
                  )}
                </InfiniteScroll>
              )}
            </TabPanel>
            <TabPanel value={value} index={1}>
              {loadedData.loading ? (
                <div className="loadingContent">
                  <PropagateLoader
                    color={"rgba(var(--text-heading-dark))"}
                    size={"1.5rem"}
                  />
                </div>
              ) : (
                <InfiniteScroll
                  className="infiniteScroller ShipmentDiv"
                  pageStart={0}
                  loadMore={() => loadMore("2")}
                  hasMore={hasMore.loaded}
                  loader={
                    <div className="bottomLoader">
                      <CircularProgress size="1.5rem" />
                    </div>
                  }
                  useWindow={false}
                >
                  {loadedData.data.length ? (
                    loadedData.data.map((ele, index) => {
                      return (
                        <ShipmentCard
                          key={ele.ShipmentId}
                          index={index}
                          handleDrawer={handleDrawer}
                          loadedData={ele}
                        />
                      );
                    })
                  ) : (
                    <span className="noShipmentsDiv">Shipment not found!</span>
                  )}
                </InfiniteScroll>
              )}
            </TabPanel>
            <TabPanel value={value} index={2}>
              {arrivedData.loading ? (
                <div className="loadingContent">
                  <PropagateLoader
                    color={"rgba(var(--text-heading-dark))"}
                    size={"1.5rem"}
                  />
                </div>
              ) : (
                <InfiniteScroll
                  className="infiniteScroller ShipmentDiv"
                  pageStart={0}
                  loadMore={() => loadMore("3")}
                  hasMore={hasMore.arrived}
                  loader={
                    <div className="bottomLoader">
                      <CircularProgress size="1.5rem" />
                    </div>
                  }
                  useWindow={false}
                >
                  {arrivedData.data.length ? (
                    arrivedData.data.map((ele, index) => {
                      return (
                        <ShipmentCard
                          key={ele.ShipmentId}
                          index={index}
                          handleDrawer={handleDrawer}
                          loadedData={ele}
                        />
                      );
                    })
                  ) : (
                    <span className="noShipmentsDiv">Shipment not found!</span>
                  )}
                </InfiniteScroll>
              )}
            </TabPanel>
          </div>
          {/* {context.showMilestone &&
          context.shipmentdetails.TransportMode === "SEA" ? (
            <ContainerDetails onDrawerChange={() => setOpen((prev) => !prev)} />
          ) : null}

          {context.showMilestone &&
          context.shipmentdetails.TransportMode === "AIR" ? (
            <FlightData onDrawerChange={() => setOpen((prev) => !prev)} />
          ) : null} */}
        </main>
        <Drawer
          variant="persistent"
          className={classes.drawer}
          anchor="right"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className="shipmentsListingDetails">
            {open ? (
              <ShipmentDetails
                detailData={detailData}
                close={() => {
                  setOpen(false);
                  context.setSelectedIndex(null);
                }}
              />
            ) : null}
          </div>
        </Drawer>
      </div>
      <Modal open={modalOpen} onClose={handleClose}>
        <Box sx={style} className="advSearchModalContainer">
          <div className="advSearchModalContainerHeading mb-3">
            <h5>Filters</h5>
            <CloseIcon className="pointer" onClick={handleClose} />
          </div>
          <AdvSearch close={handleClose} />
        </Box>
      </Modal>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      className="shipmentsListingHomeTabContent"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
    >
      {value === index && (
        <div className="shipmentsListingHomeTabContentInner">{children}</div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  drawer: {
    width: "30%",
    flexShrink: 0,
    minWidth: "25rem",
  },
  drawerPaper: {
    width: "30%",
    minWidth: "25rem",
    top: "auto",
    height: "calc(100% - 3rem)",
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
    // [theme.breakpoints.up('sm')]: {
    //     width: theme.spacing(9) + 1,
    // },
  },
}));

export default ShipmentsListing;
